<template>
  <svg class="bubble-vect" xmlns="http://www.w3.org/2000/svg" :view-box.camel="bubbleViewbox">
    <g fill="#ffffff" fill-rule="evenodd">
      <rect
        class="d-none"
        :id="uuid + 'big'"
        x="-139.5"
        :y="-69 + (100 - (hMod * hFactor))"
        width="340"
        :height="hMod * hFactor" rx="22"
        ry="22"
        ref="bigBubble"
      />
      <g stroke="#eee">
        <path ref="smallBubble" :d="smallD"/>
        <path class="pointer" d="M38.5,30.25 L30.5,39 L22.5,30.25"/>
      </g>
    </g>
  </svg>
</template>

<script>
  import { TweenLite, Back } from 'gsap'
  import MorphSVGPlugin from 'gsap/src/uncompressed/plugins/MorphSVGPlugin'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'MomentBubble',
    mixins: [ StateMixin ],
    props: {
      open: Boolean,
      hFactor: { type: Number, required: true },
      hMod: { type: Number, required: true }
    },
    data () {
      return {
        smallD: 'M16,0.5 C7.43958638,0.5 0.5,7.43958638 0.5,16 C0.5,24.5604136 7.43958638,31.5 16,31.5 L43,31.5 C51.5604136,31.5 58.5,24.5604136 58.5,16 C58.5,7.43958638 51.5604136,0.5 43,0.5 L16,0.5 Z',
        bigD: null,
        tween: null
      }
    },
    watch: {
      open ( val ) {
        let target = val ? this.bigD : this.smallD
        let delay = val ? 0 : 0.25
        this.tween ? this.tween.play( 0 ) : this.morphBubble( target, 0.65, delay )
      },
      hFactor () {
        if ( this.open ) {
          this.$nextTick( function () {
            this.makeTween( this.bigD, 0 )
          } )
        }
      }
    },
    computed: {
      bubbleViewbox () {
        return this.winW < 768 ? '0 0 61 41' : '0 0 70 41'
      }
    },
    methods: {
      makeTween ( target, time = 0.65, delay = 0 ) {
        return TweenLite.to( this.$refs.smallBubble, time, {
          morphSVG: {
            shape: target,
            shapeIndex: [ -3 ]
          },
          ease: Back.easeInOut.config( 1 ),
          delay: delay,
          onUpdate: () => {
            if ( this.tween.progress() > 0.9 ) this.$emit( 'prog', 1 )
          }
        } )
      },
      morphBubble ( target ) {
        this.tween = this.makeTween( target )
        this.tween.pause()
      }
    },
    mounted () {
      this.bigD = MorphSVGPlugin.convertToPath( this.$refs.bigBubble )
      this.morphBubble( this.bigD )
      if ( this.open ) this.tween.play( 0 )
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/global/the_goods';

  .bubble-vect {
    will-change : transform; // fixes overflow bug in Chrome

    @include screen-md-lg-xl {
      transform : translateX(6px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/svg/MomentBubble.vue